<template>
  <div class="spinner" />
</template>
<script>
export default {
  name: "InitialLoadingScreen"
};
</script>